import { inject, Injectable } from '@angular/core';
import {
	ApiResponse,
	VehicleGpsTrackingRecordDto,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { UltramarineApiService } from '../../core/api/ultramarine-api.service';

@Injectable({
	providedIn: 'root',
})
export class GpsTrackingService {
	#api = inject(UltramarineApiService);

	getVehiclesStats(): Observable<ApiResponse<VehicleGpsTrackingRecordDto[]>> {
		return this.#api.get('gps-tracking/vehicles/stats');
	}
}
